/**
 * Converts open engine orders into price line descriptors for the candlestick chart.
 * Buy orders render in green, sell orders in red. Labels show margin mode like Nado:
 * "Limit (Cross) 38.285" or "Limit (Iso) 38.285"
 */

export interface OrderPriceLineData {
  price: number;
  side: 'buy' | 'sell';
  color: string;
  title: string;
}

// Minimal shape needed from EngineOrder — avoids importing heavy engine-client in a pure util
interface OrderInput {
  price: { toNumber: () => number };
  totalAmount: { isGreaterThanOrEqualTo: (n: number) => boolean };
  // Some order types include digest/nonce but we only need price and side
}

// Exact Nado TradingView green/red for buy/sell limit lines
const BUY_COLOR = '#4CAF50';
const SELL_COLOR = '#FF5252';

export function getOrderPriceLinesFromEngineOrders(
  orders: OrderInput[],
  marginMode: 'cross' | 'isolated' = 'cross',
): OrderPriceLineData[] {
  const modeLabel = marginMode === 'cross' ? 'Cross' : 'Iso';

  return orders.map((order) => {
    const price = order.price.toNumber();
    const isBuy = order.totalAmount.isGreaterThanOrEqualTo(0);
    const side: 'buy' | 'sell' = isBuy ? 'buy' : 'sell';
    const color = isBuy ? BUY_COLOR : SELL_COLOR;
    const title = `Limit (${modeLabel}) ${price}`;

    return { price, side, color, title };
  });
}
